import { Box, useColorModeValue, BoxProps } from "@chakra-ui/react";
import React, { ReactElement } from "react";
import { useLocation } from "react-router-dom";

export type PageProps = {
  children?: ReactElement;
  orgRequired?: boolean;
} & BoxProps;

export const Page = ({ children, orgRequired, ...boxProps }: PageProps) => {
  const bg = useColorModeValue("white", "black");
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");
  const maxWidth = isAdminPage ? "none" : "container.lg";

  return (
    <Box display="flex" flexDirection="column" height="100%" {...boxProps}>
      <Box padding={[4, 6, 8]} paddingY={[6, 8, 12]}>
        <Box maxWidth={maxWidth} backgroundColor={bg} borderRadius="lg" marginInline="auto">
          <Box id="page-content" padding={[4, 6, 8]}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
